import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quotes-primary",
  "use": "icon-quotes-primary-usage",
  "viewBox": "0 0 19.01 25.41",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.01 25.41\" id=\"icon-quotes-primary\"><defs><style>#icon-quotes-primary .cls-1{fill:#fff;}#icon-quotes-primary .cls-2{fill:#046eb6;}</style></defs><polygon class=\"cls-2\" points=\"19.01 25.41 19.01 0 0 0 0 25.41 9.5 21.5 19.01 25.41\" /><path class=\"cls-1\" d=\"m8.36,10.51v3.48h-3.48v-3.12l1.58-3.65h1.48l-.95,3.29h1.38Zm4.8,0v3.48h-3.48v-3.12l1.58-3.65h1.48l-.95,3.29h1.38Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol